import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { NetworkData } from '@root/entities/network'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

export const fetchNetworkDataRequestAction = action(async (ctx) => {
  const { tradeApiClient } = ctx.get(tradeApiClientAtom)

  const mappedResult = pipe(
    await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.services.servicesNetworkDataList, []),
    ),
    Result.map((it) => NetworkData.fromDto(it)),
    Result.mapError(ApiError.fallbackToUnknown),
  )
  return mappedResult
}, 'fetchNetworkDataRequestAction')
